<template>
  <div>
    <div
      class="m-wap-page"
      v-if="isHome"
    >
      <router-view></router-view>
    </div>
    <div v-else>
      <div class="m-wap-page" :style="{ background: otherBgImg ? otherBgImg : '#ffffff' }"></div>
      <router-view></router-view>
    </div>
    <div class="return-icon" v-if="isShowBack" @click="goReturn" :style="{'background-color':configStyle?configStyle.themeColor:''}">
      <div class="return-inner">
        <span class="icontemp fanhui"></span>
      </div>
    </div>
  </div>
</template>

<script>

import { $subscriber } from "fire-wind-water/tools/subscriber";
import {interact, URLS } from "fire-wind-water";
//import { ck } from "fire-wind-water/cookie";
import { tenantId } from "../common/sbase.js";
import member from "../services/member.js";

export default {
  name: "Wap",
  data() {
    return {
      contactInfo: {},
      avatar: "",
      configStyle: null,
      isHome: true,
      isShowBack: false,
      homeBgImg: "url(./images/bgImg.png) no-repeat center/100% 100%",
      otherBgImg: "",
      configStyle1: {
        nameColor: "",
        formColor: "",
        mettingBgColor: "",
        saveBbtnColor: "",
        themeColor: "",
        homeBgImg: "",
        borderColor: "",
        formRowBgColor: "",
        mettingTypeColor: "",
        mettingStatus: {
          proposedColor: "",
          launchedColor: "",
          completedColor: "",
          proposedBgColor: "",
          launchedBgColor: "",
          completedBgColor: ""
        }
      }
    };
  },
  methods: {
    isLink() {
      if (interact.isMobile != 1) {
        window.location.hash = "#/pc";
      }
      if (location.hash.indexOf("home") != -1) {
        this.isHome = true;
      } else {
        this.isHome = false;
      }
    },
    goReturn(){
      if(this.isHome) {
        const url = decodeURIComponent(URLS.getURL('backUrl') || URLS.getURL('returnUrl') || URLS.getHash('backUrl') || URLS.getHash('returnUrl'));
        window.$sk.goto(url);
      }else{
        this.$router.replace('/wap/home');
      }
    }
  },
  created() {
    this.isShowBack = URLS.getURL('backUrl') ||  URLS.getURL('returnUrl') || URLS.getHash('backUrl') ||  URLS.getHash('returnUrl');
    document.title = "个人中心";
    this.isLink();
    member
      .themeStyle({ tenantId: tenantId, type: "usercenter" })
      .subscribe(data => {
        if (data.result == "0") {

          this.configStyle = JSON.parse(data.content.style);

          if (!this.configStyle) {
            this.configStyle = this.configStyle1;
          }
          $subscriber.emit("config-style",this.configStyle);
//          ck.cookie("configStyle", this.configStyle);
          if (this.configStyle.otherBgImg) {
            this.otherBgImg =
              "url(" +
              this.configStyle.otherBgImg +
              ") no-repeat center/100% 100%";
          }
        } else {
          this.$message.error(data.desc);
        }
      });
    $subscriber.subscribe("s-contact-init", data => {
      this.contactInfo = data;
      this.avatar = data.headImgUrl;
    });
  },
  watch: {
    $route: {
      handler: function() {
        this.isLink();
      },
      // 深度观察监听
      deep: true
    }
  }
};
</script>

<style scoped></style>
